/**
 * 将嵌套对象转换为扁平对象，键名用下划线连接
 * @param {Object} obj - 需要扁平化的对象
 * @param {string} [prefix=''] - 前缀，默认值为空
 * @param {Object} [result={}] - 存储扁平化结果的对象
 * @returns {Object} - 扁平化后的对象
 */
function flattenObject(obj, prefix = '', result = {}) {
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const newKey = prefix ? `${prefix}_${key}` : key; // 拼接键名
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                // 递归处理子对象
                flattenObject(obj[key], newKey, result);
            } else {
                // 存储最终的键值对
                result[newKey] = obj[key];
            }
        }
    }
    return result;
}

// 导出方法，供其他模块使用（例如在 Node.js 或 ES6 中）
export default flattenObject;
